/* eslint-disable react/react-in-jsx-scope */
// ** Third Party Components
import React from 'react'
import { Fragment } from 'react'
import Proptypes from 'prop-types'
import classnames from 'classnames'
import { Spinner } from 'reactstrap'

import './ui-loader.scss'

const UILoader = props => {
  const { children, blocking, loader, className, tag, overlayColor } = props

  const Tag = tag

  return (
    <Tag className={classnames('ui-loader', { [className]: className, show: blocking })}>
      {children}
      {blocking ? (
        <Fragment>
          <div
            className='overlay' /*eslint-disable */
            {...(blocking && overlayColor ? { style: { backgroundColor: overlayColor } } : {})}
          ></div>
          <div className="loader-backdrops"></div>
          <div className='loader'>{loader}</div>
        </Fragment>
      ) : null}
    </Tag>
  )
}

export default UILoader

UILoader.defaultProps = {
  tag: 'div',
  blocking: false,
  // eslint-disable-next-line react/react-in-jsx-scope
  loader: <Spinner color='primary' />
}

UILoader.propTypes = {
  tag: Proptypes.string,
  loader: Proptypes.any,
  className: Proptypes.string,
  overlayColor: Proptypes.string,
  blocking: Proptypes.bool.isRequired
}

